export type PledgeAccordingItemProps = {
  no: number;
  interestRate: number;
  amount: number;
}

export const PledgeAccordingItem = (props: PledgeAccordingItemProps) => {
  return (
    <>
      <div className="card-body row mx-0 py-0">
        <div className="col px-0">{`#${props.no + 1}`}</div>
        <div className="col px-0">{`${new Intl.NumberFormat('en').format(props.interestRate*100)}%`}</div>
        <div className="col px-0">{`${new Intl.NumberFormat('en').format(props.amount)}`}</div>
      </div>
    </>
  )
}